import {useAuthStore} from "~/store/auth";

export default defineNuxtRouteMiddleware(async (to) => {

    // initialize auth store
    const authStore = useAuthStore();

    //request check is authorized
    await authStore.checkIsAuthorized();

    // check logged user
    if (authStore.currentUserData.id) {
        switch (to.name) {
            case "sign-in":
                return navigateTo("/admin/resumes");
        }
    } else {
        switch (to.name) {
            case "admin-users":
            case "admin-resumes":
            case "admin-manage-form":
                return navigateTo("/sign-in");
        }
    }

});
